import React, { useState } from 'react';
import Modal from 'components/shared/Modal/Modal';
import './SoftwareUploadModal.css';
import { VERSION_MANAGER_OPTIONS } from 'pages/AdminPage/utils';

export const SoftwareUploadModal = (props) => {
  const [closeModal, setCloseModal] = useState(false);

  return (
    <Modal
      close={() => {
        props.close();
      }}
      animateX={false}
      closing={props.closeModal || closeModal}
      opaque={true}
      height={200}
      width={360}
    >
      {!props.error && (!props.success || props.progress < 100) ? (
        <div className="SoftwareUploadModal_Progress_OuterDiv">
          <span className="SoftwareUploadModal_Progress_Text">Uploading</span>
          <div className="SoftwareUploadStatusBar_ProgressBar">
            <div className="SoftwareUploadStatusBar_BarSpace" />
            <div className="SoftwareUploadStatusBar_BarFilled" style={{ width: props.progress + '%' }} />
          </div>
        </div>
      ) : props.error ? (
        <div className="SoftwareUploadModal_Error_Div">
          <div className="SoftwareUploadModal_Error_Header">Error</div>
          <div className="SoftwareUploadModal_Error_Message">
            An error occurred while uploading the{' '}
            {props.selectionMode === VERSION_MANAGER_OPTIONS.SOFTWARE ? 'software' : 'beam table'} package. For support,
            contact
            <a className="Global_Link" href="mailto:support@pivotalcommware.com">
              {' '}
              support@pivotalcommware.com
            </a>
          </div>
          <button className="Global_RoundedButton SoftwareUploadModal_Complete_Button" onClick={props.close}>
            OK
          </button>
        </div>
      ) : (
        <div className="SoftwareUploadModal_Success_Div">
          <div className="SoftwareUploadModal_Success_Header">Success</div>
          <div className="SoftwareUploadModal_Success_Message">
            Software has been successfully uploaded. Please allow up to a few minutes for the new version to display in
            the version list
          </div>
          <button className="Global_RoundedButton SoftwareUploadModal_Complete_Button" onClick={props.close}>
            OK
          </button>
        </div>
      )}
    </Modal>
  );
};
